'use client'

import { ServicePage, ServicePageProps } from '@/screens/service'

import { useRegion } from '@/entities/regions'

import { useServicePageView } from '@/shared/integrations/mindBox/hooks/useServicePageView'

type Props = ServicePageProps

const ServicePageContent = ({ sliderImages, categories }: ServicePageProps) => {
	const { currentRegion } = useRegion()
	const title = `Авторизованные сервисные центры Apple в ${currentRegion.REGION_P_NAME}`

	useServicePageView(title)

	return <ServicePage sliderImages={sliderImages} categories={categories} />
}

export function ServiceClient({ sliderImages, categories }: Props) {
	return <ServicePageContent sliderImages={sliderImages} categories={categories} />
}
